import * as Phaser from "phaser-ce"
import { CCUtils } from "../../../../common/CCUtils"
import { log } from "../../../../common/Logging"
import { Scale } from "../../../utils/Scale"
import { PongAssets } from "../PongAssets"
import { PongPos } from "../PongPos"
import { Loc, PongState } from "../PongState"

export class Cig extends Phaser.Sprite {

    private static readonly FUNNEL_VELOCITY = 0.4
    private static CRUMPLE: Phaser.Sound

    isReset = true
    availablePosition
    private pongState: PongState
    private crumpleAnim: Phaser.Animation
    private paddleHasBeenHit = false
    private xBoundary: number
    private hitFunnel = false
    private readonly cig: boolean

    fps: number = PongPos.baseFps()

    constructor(state: PongState, y: number, group: Phaser.Group, forceCig = false) {
        super(state.game, 0, y, CCUtils.returnRandom(PongAssets.PONG_CIGARETTE,
            forceCig ? PongAssets.PONG_CIGARETTE : PongAssets.PONG_VAPE))
        this.cig = this.key === PongAssets.PONG_CIGARETTE
        this.pongState = state
        if (this.cig) {
            Scale.scaleSprite(this, 0.5)
        } else {
            Scale.scaleSprite(this, 0.7)
        }

        this.availablePosition = y
        this.game.physics.enable(this, Phaser.Physics.ARCADE)
        this.body.width = 1

        group.add(this)

        this.crumpleAnim = this.animations.add("crumple")
        this.crumpleAnim.onComplete.add(() => {
            this.resetCig()
        })

        Cig.CRUMPLE = this.game.add.sound(PongAssets.CRUMPLE, 0.3)

        this.x = Scale.width() - this.width * 1.1
    }

    update() {
        // To accommodate monitors at fps other than 60Hz, we adjust velocities based on the framerate
        this.getFPS().then(fps => this.fps = fps)

        if (!this.isReset && this.pongState.undefendedCigs < PongState.MAX_UNDEFENDED_CIGS) {
            if (!this.hitFunnel && this.xBoundary >= this.x) {
                log.debug("Cig hit funnel.")
                let secondLoc: Loc
                if (this.y <= this.pongState.midLoc.y) {
                    secondLoc = this.pongState.upperLoc
                } else {
                    secondLoc = this.pongState.lowerLoc
                }
                this.body.velocity.x = (this.pongState.midLoc.x - secondLoc.x) * Cig.FUNNEL_VELOCITY * this.fpsAdjustment()
                this.body.velocity.y = (this.pongState.midLoc.y - secondLoc.y) * Cig.FUNNEL_VELOCITY * this.fpsAdjustment()
                this.hitFunnel = true
            }
            if (this.hitFunnel && this.x <= this.pongState.midLoc.x) {
                log.debug("Reset cig for hitting midloc")
                this.resetCig()
                this.pongState.undefendedCig(this.cig)
            }

            this.game.physics.arcade.overlap(this.pongState.paddle, this, this.hitPaddle, null, this)
        }
    }

    resetCig = () => {
        if (!this.isReset) {
            this.isReset = true
            this.hitFunnel = false
            this.paddleHasBeenHit = false

            const newLoc = this.pongState.abandonedCigLocations.shift()
            if (newLoc) {
                this.resetX()
                this.y = newLoc
                this.availablePosition = newLoc
            }
            this.body.velocity.x = 0
            this.body.velocity.y = 0
            this.animations.frame = 0
        }
    }

    makeFly = () => {
        this.isReset = false
        this.xBoundary = this.findXBoundaryForCig()

        this.body.velocity.x = -100 * Scale.scaleAmount() * this.fpsAdjustment()
        this.pongState.abandonedCigLocations.push(this.availablePosition)
    }

    hitPaddle = () => {
        if (!this.paddleHasBeenHit) {
            this.paddleHasBeenHit = true
            this.body.velocity.x = 0
            this.crumpleAnim.play(10)
            Cig.CRUMPLE.play()
        }
    }

    findXBoundaryForCig = (): number => {
        if (this.y <= this.pongState.midLoc.y) {
            return (this.y - this.pongState.midLoc.y) / this.pongState.upperLineSlope + this.pongState.midLoc.x
        } else {
            return (this.y - this.pongState.midLoc.y) / this.pongState.lowerLineSlope + this.pongState.midLoc.x +
                Scale.width() * 0.005
        }
    }

    private resetX = () => {
        this.x = Math.floor(Scale.width() - this.width * 1.1)
    }

    getFPS = (): Promise<number> => {
        return new Promise(resolve => {
            requestAnimationFrame(t1 => {
                requestAnimationFrame(t2 => resolve(1000 / (t2 - t1)))
            })
        })
    }

    fpsAdjustment = () => PongPos.baseFps() / this.fps

}
